<template>
<!-- 企业信息 -->
<div class="viewContainer">
  
  <div class="main_container">
    <b style="font-size: 16px;display: block;margin: 10px 0 0 20px;">营业执照</b>
    <el-row style="padding: 0 20px 20px 20px;">
      <el-col :span="12" style="border-right: 1px solid #e5e5e5;">
        <div style="text-align: center;">
          <!-- <img src="../../assets/img/hdcj.png" style="width: 360px; height: 200px;border-radius: 5px;"/> -->
          <el-image :src="yyzzImg" v-if="yyzzImg" @click="handleClickItem" :preview-src-list="[yyzzImg]"
          style="width: 360px; height: 200px;border-radius: 5px;"/>
          <i v-else class="el-icon-plus rxghUploader" style="width: 360px; height: 200px;border-radius: 5px;"></i>
        </div>
        <div style="width: 90%;">
          <p style="font-size: 14px; color: #222;">上传要求</p>
          <p style="font-size: 14px; color: #888;">1. 请上传清晰的营业执照照片，jpg、png格式均可，文件不超过2MB ； 2. 请确保营业执照边框完整，字迹清晰可见，亮度均匀，文字正向显示；</p>
          <p style="font-size: 14px; color: #222;">上传示例</p>
          <div style="text-align: center;"><img src="../../assets/img/yyzz.png" style="width: 90%;"/></div>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form label-width="150px">
          <el-form-item label="主体类型：">
            <el-radio-group v-model="enterpriseAttribute" disabled>
              <el-radio :label="1">企业</el-radio>
              <el-radio :label="2">个体工商户</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="企业名称：">
            <el-input v-model="qyName" maxlength="20" placeholder="请输入企业名称" disabled style="width: 60%;"/>
          </el-form-item>
          <el-form-item label="企业法人：">
            <el-input v-model="qyLegal" maxlength="20" placeholder="请输入企业法人" disabled style="width: 60%;"/>
          </el-form-item>
          <el-form-item label="信用代码：">
            <el-input v-model="creditCode" maxlength="20" placeholder="请输入信用代码" disabled style="width: 60%;"/>
          </el-form-item>
          <el-form-item label="有效期限：">
            <el-date-picker type="date" v-model="startTime" :editable="false" value-format="yyyy-MM-dd"
            placeholder="开始日期" style="width:22%;" disabled/><span style="margin: 0 8px;">至</span>
            <el-date-picker type="date" v-model="endTime" :editable="false" value-format="yyyy-MM-dd"
            placeholder="结束日期" style="width:22%;" disabled/>
            <el-checkbox v-model="longTermOne" style="margin-left: 10px;" disabled>长期有效</el-checkbox>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
  
  <div class="main_container">
    <b style="font-size: 16px;display: block;margin: 10px 0 0 20px;">法人身份证(选填)</b>
    <el-row style="padding: 0 20px 20px 20px;">
      <el-col :span="12" style="border-right: 1px solid #e5e5e5;">
        <div class="rxgh">
          <div class="rxghDiv">
            <el-image :src="rxLong" v-if="rxLong" class="rxghAvatarImg" @click="handleClickItem" :preview-src-list="[rxLong]"/>
            <el-upload v-else class="avatar-uploader" action accept=".jpg, .png" :show-file-list="false" :before-upload="(file)=>beforeIDcard(file, 1)">
              <i class="el-icon-plus rxghUploader"></i>
            </el-upload>
            <img src="../../assets/img/aicon36.png" class="chahao" @click.stop="delIDcard(1)" v-show="rxLong"/>
            <p class="rxghSM"> 法人或经营者身份证正面（人像） </p>
          </div>
          <div class="rxghDiv">
            <el-image :src="ghLong" v-if="ghLong" class="rxghAvatarImg" @click="handleClickItem" :preview-src-list="[ghLong]"/>
            <el-upload v-else class="avatar-uploader" action accept=".jpg, .png" :show-file-list="false" :before-upload="(file)=>beforeIDcard(file, 2)">
              <i class="el-icon-plus rxghUploader"></i>
            </el-upload>
            <img src="../../assets/img/aicon36.png" class="chahao" @click.stop="delIDcard(2)" v-show="ghLong"/>
            <p class="rxghSM"> 法人或经营者身份证反面（国徽） </p>
          </div>
        </div>
        <div style="width: 90%;">
          <p style="font-size: 14px; color: #222;">上传要求</p>
          <p style="font-size: 14px; color: #888;">1. 请上传清晰的法人身份证照片，jpg、png格式均可，文件不超过2MB ； 2. 请确保身份证边框完整，字迹清晰可见，亮度均匀，文字正向显示；</p>
          <p style="font-size: 14px; color: #222;">上传示例</p>
          <div style="text-align: center;"><img src="../../assets/img/sfz.png" style="width: 90%;"/></div>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form label-width="150px">
          <el-form-item label="法人姓名：">
            <el-input v-model="sfzxm" maxlength="21" placeholder="请输入法人姓名" style="width: 60%;"/>
          </el-form-item>
          <el-form-item label="身份证号：">
            <el-input v-model="sfzhm" maxlength="21" placeholder="请输入身份证号" style="width: 60%;"/>
          </el-form-item>
          <el-form-item label="居住地址：">
            <el-input v-model="jzdz" maxlength="200" placeholder="请输入居住地址" style="width: 60%;"/>
          </el-form-item>
          <el-form-item label="有效期限：">
            <el-date-picker type="date" v-model="ksTime" :editable="false" value-format="yyyy-MM-dd"
            placeholder="开始日期" style="width:22%;"/><span style="margin: 0 8px;">至</span>
            <el-date-picker type="date" v-model="jsTime" :editable="false" value-format="yyyy-MM-dd"
            placeholder="结束日期" style="width:22%;" :disabled="longTermTwo"/>
            <el-checkbox v-model="longTermTwo" style="margin-left: 10px;">长期有效</el-checkbox>
          </el-form-item>
          <el-form-item label="发证机关：">
            <el-input v-model="fzjg" maxlength="21" placeholder="请输入发证机关" style="width: 60%;"/>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
  
  <div class="main_container">
    <b style="font-size: 16px;display: block;margin: 10px 0 0 20px;">入驻信息</b>
    <el-form label-width="130px" style="display: flex;margin-top: 10px;">
      <el-form-item label="经营区域：">
        <el-cascader v-model="address" placeholder="请选择城市" :options="jyqyOptions"
          filterable clearable @change="handlejyqy" style="width: 70%" disabled/>
      </el-form-item>
      <el-form-item label="入驻时间：">
        <el-input v-model="joinTime" maxlength="20" placeholder="请输入" style="width: 70%;" disabled/>
      </el-form-item>
      <el-form-item label="联系姓名：">
        <el-input v-model="linkman" maxlength="20" placeholder="请输入联系人姓名" style="width: 70%;" disabled/>
      </el-form-item>
      <el-form-item label="联系方式：">
        <el-input v-model="linkphone" maxlength="11" placeholder="请输入联系手机号" style="width: 70%;" disabled/>
      </el-form-item>
    </el-form>
    <el-form label-width="130px">
      <el-form-item label="企业介绍：">
        <el-input type="textarea" v-model="addressDetail" placeholder="请输入企业介绍，最多输入500个字"
        :autosize="{ minRows: 3, maxRows: 6}" show-word-limit maxlength="500" style="width: 70%;"/>
      </el-form-item>
    </el-form>
  </div>
  
  <div class="main_container">
    <b style="font-size: 16px;display: block;margin: 10px 0 0 20px;">资质证书</b>
    <div class="upPictures">
      <div class="multigraph" v-for="(item,index) in zzzsImg" :key="index" :data-img="item">
        <el-image :src="item" class="seeLarge" fit="cover" @click="handleClickItem" :preview-src-list="zzzsImg"/>
        <div class="chahao" @click.stop="delZzzs(index)"> <img src="../../assets/img/aicon36.png"/> </div>
      </div>
      <!-- 上传图片 -->
      <el-upload action multiple v-if="zzzsFlag < 15" :before-upload="beforeUploadZzzs" accept=".png, .jpg,.jpeg">
        <i class="el-icon-plus upBtn"></i>
      </el-upload>
      <p class="spPicWenan">请上传资质证书或荣誉整数,支持JPG,PNG格式，单张图片最大5MB，最多上传15张</p>
    </div>
  </div>
  
  <div class="main_container" style="margin-bottom: 50px;">
    <b style="font-size: 16px;display: block;margin: 10px 0 0 20px;">旗下店铺</b>
    <div style="width: 98%;margin: 10px auto;">
      <el-table :data="subsidiaryStoresList" border>
        <el-table-column label="线下店名" align="center">
          <template scope="scope">{{scope.row.name}}</template>
        </el-table-column>
        <el-table-column label="管理者" align="center">
          <template scope="scope">{{scope.row.contacts}}</template>
        </el-table-column>
        <el-table-column label="管理者手机号" align="center">
          <template scope="scope">{{scope.row.phone}}</template>
        </el-table-column>
        <el-table-column label="店铺管理员" align="center">
          <template scope="scope">{{scope.row.staffCount}}</template>
        </el-table-column>
        <el-table-column label="总成交额" align="center">
          <template scope="scope">￥{{scope.row.profit}}</template>
        </el-table-column>
        <el-table-column label="详细地址" align="center">
          <template scope="scope">{{scope.row.address}}</template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrent"
      :current-page="pageIndex" :page-size="10" :total="totalRowsCount" style="margin:10px 0;float:right"/>
    </div>
  </div>
  <div class="gudingdibu">
    <el-button type="danger" @click="handleGive()">保存</el-button>
  </div>

  <!-- 初始化弹框 -->
  <el-dialog title="请选择企业" :visible.sync="dialogSksz" width="25%" center>
    <el-form class="findform">
      <el-form-item label="企业名称：" style="display:flex;">
        <el-select v-model="enterpriseId" filterable placeholder="请选择企业" @change="handleChangeQymc">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
  
</div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, provincegetcountys, getenterprise, toolsOcr } from '../../api/newOss';
import { enterpriseGetinfo, editEnterprise, getStoreList } from "../../api/attractInvestment";
  export default {
    name: "enterpriseinfo",
    mixins: [alertTrends],
    data () {
      return {
        yyzzImg: '',
        yyzzDuan: '', // 短路经
        
        dialogSksz: false, // 收款设置
        enterpriseId:'',  // 企业id
        options1: [],

        enterpriseAttribute: 1,
        qyName: '',
        qyLegal: '',
        creditCode: '',
        startTime: '', // 开始
        endTime: '', // 结束
        longTermOne: true, // 长期有效

        rxLong: '', // 人像 - 长连接
        rxShort: '', // 人像 - 短连接
        ghLong: '', // 国徽 - 长连接
        ghShort: '', // 国徽 - 短连接

        idInfo: {}, // 身份证信息回填
        
        sfzxm: '', // 法人姓名
        sfzhm: '', // 身份证号码
        jzdz: '', // 居住地址
        ksTime: '', // 开始
        jsTime: '', // 结束
        longTermTwo: false, // 长期有效 默认勾选
        fzjg: '', // 发证机关

        address: [0], // 经营区域
        jyqyOptions: [],
        provinceId: 0, // 省id
        cityId: 0, // 市id
        zoneId: 0, // 区、县id
        joinTime: '',
        linkman: '',
        linkphone: '',
        addressDetail: '',

        zzzsImg:[], // 资质证书
        zzzsFlag: 0,
        
        subsidiaryStoresList: [], // 旗下店铺列表
        pageIndex: 1,
        totalRowsCount: 0,
        
        istrial: '',
        shopNum: '',
        frsfzh: '', // 法人身份证号
      }
    },
    methods: {
      // 回显数据
      seeData(){
        enterpriseGetinfo('',this.enterpriseId).then(data=>{
          if(data.resultCode == 1){
            let idData = data.resultObj;
            this.yyzzDuan = idData.businesslicense; // 营业执照图片集合
            this.yyzzImg = idData.businesslicense.length>0?localStorage.BaseOssUrl+idData.businesslicense[0]:''; // 营业执照图片集合
            this.zzzsImg = idData.qualification?idData.qualification.map(item=>item.replace('',localStorage.BaseOssUrl)):[]; // 企业资质图片集合
            this.rxShort = idData.idcard[0];
            this.ghShort = idData.idcard[1];
            this.rxLong = idData.idcard.length>0?localStorage.BaseOssUrl+idData.idcard[0]:''; // 法人身份证图片集合（数组第一张为正面 第二章为背面）
            this.ghLong = idData.idcard.length>0?localStorage.BaseOssUrl+idData.idcard[1]:''; // 法人身份证图片集合（数组第一张为正面 第二章为背面）
            
            let basicInfo = idData.info; // 企业基本信息
            this.provinceId = basicInfo.pid;
            this.cityId = basicInfo.cid;
            this.zoneId = basicInfo.scid;
            this.address = [basicInfo.pid,basicInfo.cid,basicInfo.scid]; // 经营区域
            this.joinTime = basicInfo.entrytime; // 入驻时间 格式：yyyy-MM-dd
            this.linkman = basicInfo.linkman; // 联系人姓名
            this.linkphone = basicInfo.linkphone; // 联系人电话
            this.addressDetail = basicInfo.desc; // 企业介绍
            
            this.enterpriseAttribute = basicInfo.enterprisetype; // 主体类型
            this.qyName = basicInfo.enterprisename; // 企业名称
            this.qyLegal = basicInfo.legalpersonname; // 企业法人
            this.frsfzh = basicInfo.legalpersonidcardno; // 法人身份证号码
            
            this.istrial=basicInfo.istrial; // istrial
            this.shopNum=basicInfo.shopNum; // shopNum
            
            let extendInfo = idData.ext; // 企业扩张信息
            if(extendInfo){
              this.creditCode = extendInfo.businesslicenseno; // 信用代码
              this.startTime = extendInfo.businesslicense_bdate; // 有效期限-开始
              this.endTime = extendInfo.businesslicense_edate; // 有效期限-结束
              this.longTermOne = extendInfo.businesslicense_ispermanent==1?true:false; // 营业执照是否长期有效 0=否 1=是
              
              this.sfzxm = extendInfo.legalperson_name; // 法人姓名
              this.sfzhm = extendInfo.legalperson_idcard_no; // 身份证号
              this.jzdz = extendInfo.legalperson_idcard_address; // 居住地址
              this.ksTime = extendInfo.legalperson_idcard_bdate; // 有效期限-开始
              this.jsTime = extendInfo.legalperson_idcard_edate; // 有效期限-结束
              this.longTermTwo = extendInfo.legalperson_idcard_ispermanent==1?true:false; // 法人身份证是否长期有效 0=否 1=是
              this.fzjg = extendInfo.legalperson_idcard_institution; // 发证机关
            }
            
          }else{
            this.showAlert(data.resultMsg);
          }
        })
      },
      // 保存
      handleGive(){
        if(!this.enterpriseId) {
          this.showAlert('请重新打开本功能，并选择一家店铺');
          return false;
        }
        // if (this.sfzxm == "") {
        //   this.showAlert('请输入法人姓名');
        //   return false;
        // }
        // if (this.sfzhm == "") {
        //   this.showAlert('请输入身份证号');
        //   return false;
        // }
        // if (this.jzdz == '') {
        //   this.showAlert('请输入居住地址');
        //   return false;
        // }
        // if (this.ksTime == ""||this.jsTime == "") {
        //   this.showAlert('请选择有效期限');
        //   return false;
        // }
        // if (this.fzjg == '') {
        //   this.showAlert('请输入发证机关');
        //   return false;
        // }
        if (this.addressDetail == '') {
          this.showAlert('请输入企业介绍');
          return false;
        }
        // if (this.zzzsImg.length==0) {
        //   this.showAlert('请至少上传一张资质证书');
        //   return false;
        // }
        let obj = {
          updatesource: 2, // 操作来源 1=入驻企业详情页编辑 2=企业信息页保存 默认1
          id: this.enterpriseId, // 企业Id
          name: this.qyName, // 主体名称
          enterpriseAttribute: this.enterpriseAttribute, // 主体类型
          provinceId: this.provinceId, // 省份id
          cityId: this.cityId, // 城市id
          zoneId: this.zoneId, // 区、县id
          legalPerson: this.linkman, // 联系人姓名
          legalPersonPhone: this.linkphone, // 联系人电话
          legalPersonName: this.qyLegal, // 法人姓名
          legalPersonIdCardNumber: this.frsfzh, // 法人身份证号码
          desc: this.addressDetail, // 企业介绍
          qualifications: this.zzzsImg?this.zzzsImg.map(item=>item.replace(localStorage.BaseOssUrl,'')):[], // 资质证书相对路径集合
          businessLicense: this.yyzzDuan, // 营业执照相对路径集合
          idcard: [this.rxShort?this.rxShort:'',this.ghShort?this.ghShort:''], // 法人身份证图片集合（规则：数组第一项是正面图片 第二项是背面图片）
          businesslicenseno: this.creditCode, // 营业执照信用代码
          businesslicense_bdate: this.startTime, // 营业执照生效日期
          businesslicense_edate: this.endTime, // 营业执照失效日期
          businesslicense_ispermanent: this.longTermOne==true?1:0, // 营业执照是否长期有效 0=否 1=是

          legalperson_idcard_name: this.sfzxm, // 法人身份证姓名
          legalperson_idcard_no: this.sfzhm, // 法人身份证号码
          legalperson_idcard_address: this.jzdz, // 法人身份证住址
          legalperson_idcard_bdate: this.ksTime, // 法人身份证生效日期
          legalperson_idcard_edate: this.jsTime, // 法人身份证失效日期
          legalperson_idcard_ispermanent: this.longTermTwo==true?1:0, // 法人身份证是否长期有效 0=否 1=是
          legalperson_idcard_institution: this.fzjg, // 法人身份证发证机关

          istrial: this.istrial,
          shopNum: this.shopNum,
        }
        editEnterprise(obj).then(data => {
          if (data.resultCode == 1) {
            this.showAlert('操作成功', 'success');
          }else{
            this.showAlert(data.resultMsg);
          }
        });
      },
      
      // 请选择省市
      handlejyqy(val) {
        this.provinceId = val[0];
        this.cityId = val[1];
        this.zoneId = val[2];
      },
      // 查找省+市+区
      getSsq() {
        let loginParams = {
          isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
        };
        provincegetcountys(loginParams).then(data => {
          let provinceOptions = [];
          data.resultObj.forEach(item => {
            const province = { value: item.pid, label: item.pname, children: [] };
            if (item.citys && item.citys.length > 0) {
              item.citys.forEach(city => {
                const allCityOption = { value: 0, label: "全市" };
                let cityObj;
                if (city.countys && city.countys.length > 0) {
                  cityObj = {
                    value: city.cid, label: city.cname,
                    children: [allCityOption].concat(city.countys.map(zone => ({
                      value: zone.scid, label: zone.scname
                    })))
                  };
                } else {
                  cityObj = { value: city.cid, label: city.cname, children: [allCityOption] };
                }
                province.children.push(cityObj);
              });
            } else {delete province.children;}
            provinceOptions.push(province);
          });
          this.jyqyOptions = provinceOptions;
          this.jyqyOptions.unshift({value: 0, label: "全国"});
        })
      },
      // 旗下店铺
      queryBrandStore(){
        var addParams = {
          id: this.enterpriseId, // 企业Id
          pageIndex: this.pageIndex,// 页码
          pageSize: 10 // 每页行数
        };
        getStoreList(addParams).then(data => {
          if (data.resultCode == 1) {
            this.subsidiaryStoresList = data.resultObj.resultObj;
            this.totalRowsCount = data.resultObj.rowsCount; // 总行数
          } else {
            this.subsidiaryStoresList = [];
          }
        })
      },
      // 分页
      handleCurrent(val) {
        this.pageIndex = val;
        this.queryBrandStore();
      },

      // 人像 & 国徽
      beforeIDcard(file, type) {
        // 判断图片格式
        const isJPG = file.type === 'image/png' || file.type === 'image/jpg' ||file.type === 'image/jpeg';
        // 判断图片大小
        const isLt2M = file.size / 1024 / 1024 <= 2;
        if (!isJPG) {
          this.showAlert('上传图片只支持jpg、png等格式!');
          return;
        }
        if (!isLt2M) {
          this.showAlert('上传图片大小不能超过2MB!');
          return;
        }
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          // oss 直传图片
          var obj = { type: 43 };
          getOssFile(obj).then(data => {
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
            }
          })
          var newOssPic = await uploadOSS(file,0);
          if(type == 1){
            that.rxLong = newOssPic; // 人像 - 长连接
            that.rxShort = newOssPic.replace(localStorage.BaseOssUrl,'') // 人像 - 短链接
            if(that.rxLong){
              that.seeInfo(that.rxLong,1);
            }
          }else{
            that.ghLong = newOssPic; // 国徽 - 长连接
            that.ghShort = newOssPic.replace(localStorage.BaseOssUrl,'') // 国徽 - 短链接
            if(that.ghLong){
              that.seeInfo(that.ghLong,2);
            }
          }
        };
        return file;
      },
      // 删除 - 人像 & 国徽
      delIDcard(type) {
        if(type == 1){
          this.rxLong = '';
          this.rxShort = '';
        }else{
          this.ghLong = '';
          this.ghShort = '';
        }
      },
      // 信息回填
      seeInfo(img, side){
        let obj = {
          imgurl: img, // 全路径
          type: 1,// 识别类型1=身份证 2=营业执照
        };
        toolsOcr(obj).then(data => {
          if (data.resultCode == 1) {
            const newInfo = data.resultObj;
            if (side === 1) { // 正面信息
              // 直接更新或合并信息
              Object.assign(this.idInfo, newInfo);
            } else if (side === 2) { // 反面信息
              // 合并反面特有的信息
              const backSpecificFields = ['issueAuthority', 'beginDate', 'endDate', 'ispermanent'];
              backSpecificFields.forEach(field => {
                if (newInfo[field]) {
                  this.idInfo[field] = newInfo[field];
                }
              });
            }
            console.log(this.idInfo,'回填信息');
            this.sfzxm = this.idInfo.name; // 法人姓名
            this.sfzhm = this.idInfo.idNumber; // 身份证号码
            this.jzdz = this.idInfo.address; // 居住地址
            this.ksTime = this.idInfo.beginDate; // 开始
            this.jsTime = this.idInfo.ispermanent==1?'':this.idInfo.endDate; // 结束
            this.longTermTwo = this.idInfo.ispermanent==1?true:false; // 身份证/营业执照 是否长期有效 0=否 1=是
            this.fzjg = this.idInfo.issueAuthority; // 发证机关
          } else {
            this.showAlert(data.resultMsg);
          }
        })
        
        // this.idInfo = {
        //     "name": "曹长江",
        //     "sex": "男",
        //     "ethnicity": "汉",
        //     "birthDate": "1980年4月6日",
        //     "address": "北京市大兴区黄村镇兴涛园小区56号楼3单元1502号",
        //     "idNumber": "211382198004063912",
            
        //     "issueAuthority": "北京市公安局大兴分局",
        //     "validPeriod": "2021.11.04-2041.11.04",
        //     "beginDate": "2021-11-04",
        //     "endDate": "2041-11-04",
        //     "ispermanent": 0
        // }
        
      },
      
      // 多图上传-资质证书
      beforeUploadZzzs(file) {
        const isJPG = file.type === 'image/png' || file.type === 'image/jpg' ||file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 <= 5;
        if (!isJPG) {
          this.showAlert('上传图片只支持jpg、png等格式!');
          return;
        }
        if (!isLt2M) {
          this.showAlert('上传图片大小不能超过 5MB!');
          return;
        }
        this.zzzsFlag += 1;
        if (this.zzzsFlag > 15) {
          this.showAlert('最多传入15张图片');
          return false;
        }
        var _this = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          // oss 直传图片
          let obj = {
            type: 9
          };
          getOssFile(obj).then(data => {
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
              
              uploadOSS(file,0).then(data => {
                var newOssPic = data;
                _this.zzzsImg.push(newOssPic);
              })
              
            }
          })
        };
      },
      // 删除-资质证书
      delZzzs(val) {
        let newUrl = this.zzzsImg;
        for (var i = 0; i < newUrl.length; i++) {
          if (val == i) {
            newUrl.splice(i, 1);
          }
        }
        this.zzzsImg = newUrl;
        this.zzzsFlag = this.zzzsImg.length;
      },
      // 初始化查企业
      initEnterprise(){
        let addParams = {
          userId: localStorage.Id, // 当前登陆人id
        };
        getenterprise(addParams).then(data => {
          if (data.resultCode == 1) {
            if(data.resultObj.length>1){
              this.dialogSksz = true;
              this.options1 = data.resultObj;
            } else {
              this.dialogSksz = false;
              this.enterpriseId = data.resultObj[0].id; // 默认选中第一个企业id
              this.enterpriseName = data.resultObj[0].name;
              this.seeData(); // 初始化查询列表
              this.queryBrandStore(); // 旗下店铺列表
            }
            
          }
        })
      },
      gonext(){
        if(this.enterpriseId == ""){
          this.showAlert('请选择企业名称');
          return false;
        }
        this.seeData(); // 初始化查询列表
        this.queryBrandStore(); // 旗下店铺列表
        this.dialogSksz = false;
      },
      // 获取企业名称
      handleChangeQymc(val) {
        this.options1.filter(item => {
          if(item.id == val){
            this.enterpriseName = item.name;
          }
        })
      },
      // 关闭el-image遮罩层
      handleClickItem() {
        this.$nextTick(() => {
          // 获取遮罩层dom
          let domImageMask = document.querySelector('.el-image-viewer__mask')
          if (!domImageMask) {
            return
          }
          domImageMask.addEventListener('click', () => {
            // 点击遮罩层时调用关闭按钮的 click 事件
            document.querySelector('.el-image-viewer__close').click()
          })
        })
      },
      
    },
    watch: {
      'longTermTwo'() {
        if(this.longTermTwo) {
          this.jsTime = '';
        }
      },
      
    },
    mounted() {
      this.initEnterprise(); // 初始化查企业
      this.getSsq(); // 省市区
    },
  }
</script>
<style scoped>
/* 人像 & 国徽 */
.rxgh {
  width: 100%;
  /* height: 200px; */
  margin-top: 20px;
  display: flex;
  justify-content: space-evenly;
}
.rxghDiv {
  width: 280px;
  height: 200px;
  position: relative;
}
.rxghAvatarImg {
  width: 280px;
  height: 200px;
  border-radius: 5px;
  border: 1px solid #e5e5e5;
}
.rxghUploader {
  width: 280px;
  height: 200px;
  line-height: 200px;
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
}
/* 人像 & 国徽 - 说明 */
.rxghSM {
  width: 280px;
  height: 30px;
  line-height: 30px;
  background: #333;
  border: 1px solid #333;
  position: absolute;
  bottom: -15px;
  left: 0;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  opacity: 0.6;
}
/* 删除-icon */
.chahao {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  color: #666;
  position: absolute;
  right: -8px;
  top: -5px;
  cursor: pointer;
}
/* 资质证书 */
.upPictures {
  width: 88%;
  margin: 20px 0 10px 20px;
}
.multigraph {
  width: 80px;
  height: 80px;
  position: relative;
  float:left;
  margin-right:10px;
  margin-bottom: 5px;
}
.seeLarge {
  width:80px;
  height:80px;
  cursor: pointer;
}
.chahao {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  color: #666;
  position: absolute;
  right: -8px;
  top: -8px;
  cursor: pointer;
}
.upBtn {
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #DCDFE6;
  font-size: 26px;
  color: #999;
}
.spPicWenan {
  width: 100%;
  display: inline-block;
  color: #999;
}

</style>


// WEBPACK FOOTER //
// enterpriseinfo.vue?63b7e320